<div class="home">

    <section class="title-section">
        <h1 class="title-section-text">{{'HOME.TITLE' | translate}}</h1>
        <div class="title-section-separator"></div>
        <p class="title-section-subtitle">{{'HOME.SUBTITLE' | translate}}</p>
    </section>

    <section class="button-section">
        <button class="secondaryButton" [routerLink]="[paths.MAP]">{{'HOME.VIEW_MAP' | translate}}</button>
    </section>

    <section class="categories-section">

        @for (category of categories; track $index) {

        <div class="category" [style.background-image]="getBackgroundImage(category.code)"
            [class.selectedCategory]="$first" [attr.id]="$index" (click)="toggleSelectedCategory($index)">
            <div class="category-title">
                <p>{{category.group}}:<br>{{category.tituloKey | translate}} {{'HOME.AND_MORE' | translate}} {{category.sloganKey | translate | lowercase}}</p>
                <button [routerLink]="category.route" [queryParams]="category.queryParams" class="primaryButton"
                    (click)="$event.stopPropagation()">{{'HOME.EXPLORE' | translate}}</button>
            </div>
        </div>
        }


    </section>

    <section class="categories-section-mobile">

        <app-infinite-carousel></app-infinite-carousel>

    </section>

    <!--
    <section class="map-section">
        <app-map></app-map>

    </section>

    <section class="separator"></section>

    <section class="text-section">
        <h1 class="text-section-title">Texto amplio</h1>

        <div class="text-section-description">
            <p>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et
                quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi
                nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit,
                sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.
                Ut enim ad minima veniam.</p>

            <p>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et
                quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi
                nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit,
                sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.
                Ut enim ad minima veniam.</p>
        </div>



    </section>

    -->
</div>